import { render, staticRenderFns } from "./dingtalkMessage.vue?vue&type=template&id=b8a0651c"
import script from "./dingtalkMessage.vue?vue&type=script&lang=js"
export * from "./dingtalkMessage.vue?vue&type=script&lang=js"
import style0 from "./dingtalkMessage.vue?vue&type=style&index=0&id=b8a0651c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports